export enum USER_ROLES {
  staff = "staff",
  employee = "employee",
}

export type UserRole = USER_ROLES;
